import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  title: 'Courses',
  create: 'Create new course',
  actions: 'Actions',
  deleteConfirm: 'Are you sure you want to delete this course?',
  copyConfirm: 'Are you sure you want to copy this course?',
  copySuccess: 'Course copied successfully',
  edit: 'Edit course info',
  open: 'Course editor',
  cantDelete:
    'This action is restricted due to access limitations. Please contact your administrator.',
  cantDeleteEnrollments: 'You cannot delete course with active enrollments.',
  delete: 'Delete',
  published: 'Published',
  yes: 'Yes',
  unpublished: 'Unpublished',
  no: 'No',
  public: 'Public',
  private: 'Private',
  copyCourse: 'Create copy',
  averageScore: 'Average score',
  courseDeleted: 'Course deleted successfully',
  participatory: 'Participatory',
  learners: 'Learners',
  manageAIAssistant: 'Manage AI assistant',
  courseEditor: 'Course editor',
  editInfo: 'Edit info',
  preview: 'Preview',
  analytics: 'Analytics',
  enrollLearners: 'Enroll learners',
  assignInstructors: 'Assign instructors',
  copy: 'Copy',
  emptyState1: 'It looks like you haven’t created any courses yet.',
  emptyState2: 'Let’s get started by creating your first course now!',
  viewSyllabus: 'View syllabus',
  noCoursesFound: 'No courses found matching your search term: ',
  noCoursesFound2: 'Please try a different keyword.',
};

const welsh = {
  title: 'Cyrsiau',
  create: 'Creuwch gwrs newydd',
  actions: 'Creuwch gwrs newydd',
  deleteConfirm: "Ydych chi'n siŵr eich bod am ddileu'r cwrs hwn?",
  copyConfirm: "Ydych chi'n siŵr eich bod am gopïo'r cwrs hwn?",
  copySuccess: 'Cwrs wedi’i gopïo’n llwyddiannus',
  edit: 'Golygwch wybodaeth y cwrs',
  open: 'Golygydd cwrs',
  cantDelete:
    "Mae'r gweithred hon wedi'i chyfyngu oherwydd cyfyngiadau mynediad. Cysylltwch â'ch gweinyddwr os gwelwch yn dda.",
  cantDeleteEnrollments:
    'Ni allwch ddileu cwrs gyda chofrestriadau gweithredol.',
  delete: 'Dilewch gwrs',
  published: 'Cyhoeddedig',
  yes: 'Ie',
  unpublished: 'Heb ei gyhoeddi',
  no: 'Na',
  public: 'Cyhoeddus',
  private: 'Preifat',
  copyCourse: 'Creuwch gopi',
  averageScore: 'Average score',
  courseDeleted: 'Cwrs wedi’i ddileu’n llwyddiannus',
  participatory: 'Participatory',
  learners: 'Learners',
  manageAIAssistant: 'Manage AI assistant',
  courseEditor: 'Course editor',
  editInfo: 'Edit info',
  preview: 'Preview',
  analytics: 'Analytics',
  enrollLearners: 'Enroll learners',
  assignInstructors: 'Assign instructors',
  copy: 'Copy',
};

export const coursesListText: any = getLocalizationBasedOnLang(english, welsh);
